import React, { useEffect, useState } from "react";
import ModalPortal from "../../portal/ModalPortal";
import {
  ModalActionButtonWrapper,
  ModalStyle,
  Mymodal_wrapper,
  ModalButtons,
  Form,
  ModalTitle,
  SaveButtonModal,
  DeleteButtonModal,
  DeleteMessage,
} from "../../styles/MainLayout";
import axios from "../../axios"
import { toast } from "react-toastify";

const CaloriesRangeModal = (props) => {
  const [isdelete, setDelete] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [dataToSave, setDataToSave] = useState(props?.data);
  const caloriesRangeData = props?.data;


  const handleAddSubmmision = (e) => {
    e.preventDefault();
    axios.post('calories-range', dataToSave).then(
      data => {
        props?.handleModalClose();
        props?.getData();
        toast.success('Të dhënat janë ruajtur me sukses!');
        setDisableEdit(false);
      }
    ).catch(err => {
      toast.error('Të dhënat nuk janë ruajtur!');
      console.log(err);
    });
  }

  const handleEditSubmmision = (e) => {
    e.preventDefault();
    axios.put('calories-range', dataToSave).then(
      data => {
        console.log('goingData', data);
        props?.getData();
        toast.success('Të dhënat janë përditësuar me sukses!');
        props?.handleModalClose();
        setDisableEdit(false);
      }
    ).catch(err => {
      toast.error('Të dhënat nuk janë përditësuar!');
      console.log(err);
    });
  }

  const handleDelete = (e) => {
    e.preventDefault();
    axios.delete(`calories-range/${caloriesRangeData?.id}`)
      .then(data => {
        props?.getData();
        toast.success('Të dhënat janë fshirë me sukses!');
        props?.handleModalClose();
      })
      .catch(err => {
        toast.error('Të dhënat nuk janë fshirë!');
        console.log(err);
      })
  }


  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      props?.handleModalClose()
    }
  })

  const handleChange = (e) => {
    setDisableEdit(true);
    const { name, value } = e?.target;
    setDataToSave({...dataToSave, [name]: value})
  }

  useEffect(() => {
    if (props?.isOpen) {
      setDelete(false);
    }
  }, [props?.isOpen]);

  if (props?.isOpen) {
    return (
      <>
        <ModalPortal>
          <ModalStyle>
            <div className="wholePage" onClick={() => props?.handleModalClose()} />
            <Mymodal_wrapper>

              <ModalActionButtonWrapper>
                {props?.type !== "add" ?
                  <>
                    <ModalButtons delete onClick={() => setDelete(!isdelete)}>
                      <i className={isdelete ? "fa fa-times" : "fa fa-trash"} />
                    </ModalButtons>

                    <ModalButtons close onClick={() => props?.handleModalClose()}>
                      <i className={isdelete ? "fa fa-times" : "fa fa-times"} />
                    </ModalButtons>
                  </>
                  :
                  <ModalButtons close onClick={() => props?.handleModalClose()}>
                    <i className={isdelete ? "fa fa-times" : "fa fa-times"} />
                  </ModalButtons>
                }
              </ModalActionButtonWrapper>
              {isdelete === false && (
                <Form onSubmit={props?.type == "edit" ? handleEditSubmmision : handleAddSubmmision}>
                  <ModalTitle title>{props?.type !== 'edit' ? 'Add' : 'Edit'} Calories Range</ModalTitle>
                  <div className="form-group">
                    <label>Range</label>
                    <input
                      type="text"
                      name="range"
                      className="form-control"
                      // placeholder="Range"
                      onChange={handleChange}
                      defaultValue={props?.type == 'edit' ? caloriesRangeData?.range : ""}
                      required
                    />
                  </div>

                  {props?.type === "add" && (
                    <SaveButtonModal type="submit" disabled={!disableEdit}>
                      Ruaj
                    </SaveButtonModal>
                  )}

                  {props?.type === "edit" && (
                    <SaveButtonModal type="submit" disabled={!disableEdit}>
                      Ndrysho
                    </SaveButtonModal>
                  )}
                </Form>
              )}
              {isdelete &&
                <>
                  <DeleteMessage>
                    <ModalTitle deleteMessage>Deshironi te fshini rangun {caloriesRangeData?.range}?</ModalTitle>
                    <DeleteButtonModal onClick={handleDelete}>Fshij</DeleteButtonModal>
                  </DeleteMessage>
                </>
              }
            </Mymodal_wrapper>
          </ModalStyle>
        </ModalPortal>
      </>
    );
  } else {
    return null;
  }
};

export default CaloriesRangeModal;
